import React from 'react';
import { SectionHeader, SectionTitle, TitleIcons } from "./..";
export function ScholarshipsTitle() {
  return /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(TitleIcons.Scholarships, null), /*#__PURE__*/React.createElement(SectionTitle, null, "Scholarships"));
}